"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_DIALOG_MOVING_ATTR_NAME = 'dialog-moving';
exports.CLASS_MODAL_INERT_ATTR_NAME = 'inert';
//# sourceMappingURL=attributes.js.map